import React from 'react';
import { integrationsWithLogos } from './Integrations';
import RevenueRingFloat from './RevenueRingFloat';
import WhatsAppHeroPhone from './WhatsAppHeroPhone';

/** Compact phone + floating rails for viewports below `sm`. Parent should render with `sm:hidden`. */
export default function WhatsAppHeroVisualMobile() {
  return (
    <div className="mx-auto w-full max-w-[100vw] py-4 flex justify-center px-2">
      <div className="w-full flex flex-col items-center">
        {/* Purchase pill — stacked above the phone so it never covers the Kolanut header */}
        <div className="mb-2.5 flex w-full justify-center px-1 z-30 pointer-events-none">
          <div className="flex w-[min(292px,calc(100vw-4rem))] max-w-full justify-center">
            <div className="w-[192px] max-w-[min(192px,calc(100vw-11rem))] rounded-2xl bg-white shadow-[0_16px_36px_-8px_rgba(0,0,0,0.2)] border border-gray-100 px-3 py-2 flex items-start gap-2 min-w-0">
              <img
                src="/avatar7.png"
                alt=""
                className="w-8 h-8 rounded-full object-cover border-2 border-white shadow shrink-0 mt-0.5"
              />
              <p className="min-w-0 flex-1 text-[10px] text-gray-900 leading-snug line-clamp-3 break-words">
                <span className="font-bold text-emerald-600">Purchased $20k</span>
                <span className="text-gray-400">, </span>
                <span className="text-gray-700">Win back, Shopify</span>
              </p>
            </div>
          </div>
        </div>

        {/* Phone row: integrations + device + revenue (purchase removed from here) */}
        <div className="flex flex-row items-end justify-center max-w-full">
          <aside className="flex flex-col justify-end shrink-0 w-[76px] pr-0 -mr-[52px] pointer-events-none z-20 pb-0.5">
            <div className="ml-auto flex w-max max-w-none flex-nowrap items-center justify-end gap-1.5 rounded-full bg-white/95 backdrop-blur-sm shadow-[0_12px_28px_-6px_rgba(0,0,0,0.18)] border border-gray-100 px-2.5 py-1.5">
              {integrationsWithLogos.map((integration) => (
                <div
                  key={integration.name}
                  className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-50 border border-gray-100 overflow-hidden shrink-0"
                  title={integration.title}
                >
                  <img
                    src={integration.image}
                    alt={integration.alt}
                    className="max-h-4 max-w-4 object-contain"
                  />
                </div>
              ))}
            </div>
          </aside>

          <div className="relative z-10 w-[min(308px,calc(100vw-3.25rem))] shrink-0 select-none">
            <WhatsAppHeroPhone mobile className="h-[648px] max-h-[min(82vh,680px)]" />
          </div>

          <aside className="flex flex-col justify-start shrink-0 min-w-[100px] w-[76px] pl-0 -ml-[58px] pointer-events-none z-20 pb-1 self-start pt-2 -translate-x-2 origin-top-right">
            <RevenueRingFloat compact />
          </aside>
        </div>
      </div>
    </div>
  );
}
